//npm packages
import React from 'react';
import ReactDOM from 'react-dom/client';

import * as serviceWorker from './serviceWorker';
import HomeEntryRoute from './Routes/HomeEntryRoute';
import Modal from "react-modal";
import "./index.css";
//import "./Common/modalScrollLock";

const root = ReactDOM.createRoot(document.getElementById('root'));
Modal.setAppElement("#root");

// Suppress benign ResizeObserver loop notification in development overlay
window.addEventListener('error', (e) => {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded' ||
    (typeof e.message === 'string' && e.message.includes('ResizeObserver'))
  ) {
    e.stopImmediatePropagation();
    e.stopPropagation();
  }
}, true);

root.render(
  <HomeEntryRoute />
);

serviceWorker.unregister();